import { useState } from "react";
import { Button } from "@knowtex-ai/components";
import { Check, Trash, UploadSquare } from "iconoir-react";
import EmailDraftCard from "./EmailDraftCard";

/** Renders whatever control the current step needs to be marked done. */
export default function FoiaStepAction({ request, step, onComplete }) {
  if (step.actionUiType === "email_draft") {
    return <EmailDraftCard request={request} stepKey={step.key} onSent={onComplete} />;
  }

  if (step.actionUiType === "milestone") {
    return (
      <div className="flex flex-col items-start gap-2">
        <p className="text-sm text-gray-600">Mark this milestone once it has happened.</p>
        {step.key === "uploaded" && (
          <p className="text-sm text-gray-500">
            Folder name to use: <span className="font-mono font-medium text-gray-700">{request.sharepointFolderName}</span>
          </p>
        )}
        <Button icon={Check} successLabel="Logged" onClickAsync={() => simulateDelay(onComplete)}>
          {step.milestoneLabel}
        </Button>
      </div>
    );
  }

  if (step.actionUiType === "mark_retained") {
    return (
      <div className="flex flex-col items-start gap-2">
        <p className="text-sm text-gray-600">Confirm the recording is retained and has been sent to Cortney.</p>
        <Button icon={UploadSquare} successLabel="Retained and sent" onClickAsync={() => simulateDelay(onComplete)}>
          Mark retained and sent
        </Button>
      </div>
    );
  }

  if (step.actionUiType === "request_deletion") {
    return <RequestDeletionAction onComplete={onComplete} />;
  }

  if (step.actionUiType === "mark_deleted") {
    return (
      <div className="flex flex-col items-start gap-2">
        <p className="text-sm text-gray-600">Confirm the data has been deleted for this request.</p>
        <Button icon={Trash} successLabel="Deleted" onClickAsync={() => simulateDelay(onComplete)}>
          Mark deleted
        </Button>
      </div>
    );
  }

  return null;
}

function RequestDeletionAction({ onComplete }) {
  const [confirming, setConfirming] = useState(false);

  if (!confirming) {
    return (
      <div className="flex flex-col items-start gap-2">
        <p className="text-sm text-gray-600">Log this once the COR asks for the data to be deleted.</p>
        <Button icon={Trash} variant="secondary" onClick={() => setConfirming(true)}>
          Request deletion
        </Button>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-start gap-2">
      <p className="text-sm text-gray-600">This sends a deletion task to Engineering. Continue?</p>
      <div className="flex items-center gap-3">
        <Button successLabel="Requested" onClickAsync={() => simulateDelay(onComplete)}>
          Confirm deletion request
        </Button>
        <Button variant="secondary" onClick={() => setConfirming(false)}>
          Cancel
        </Button>
      </div>
    </div>
  );
}

function simulateDelay(onComplete) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      Promise.resolve(onComplete()).then(resolve, reject);
    }, 300);
  });
}
